exports.cs = {
  REICO_NEWSLETTER: {
    EMAIL: {
      REQUIRED: 'Zadejte e-mail',
      PATTERN: 'Zadejte e-mail v platném tvaru'
    },
    REGISTER_BUTTON: 'Přihlásit k odběru',
    CONFIRMATION: '✔ Byli jste úspěšně zaregistrováni. Svou registraci, prosím, potvrďte kliknutím na odkaz, který jsme vám odeslali na e-mail. Děkujeme.'
  }
}
